const SECONDARY_IMAGE_SELECTOR = '.prd-Card_Image-lifestyle img[data-src]'
const LIFESTYLE_GRID_SELECTOR = '.clc-ProductGrid-lifestyle'

function loadSecondaryImage (img) {
  if (!img.dataset.src) return

  if (img.dataset.srcset) {
    img.srcset = img.dataset.srcset
    img.removeAttribute('data-srcset')
  }

  img.src = img.dataset.src
  img.removeAttribute('data-src')
}

function loadCardSecondaryImage (target) {
  const card = target instanceof Element ? target.closest('.prd-Card') : null

  card?.querySelectorAll(SECONDARY_IMAGE_SELECTOR).forEach(loadSecondaryImage)
}

// Delegated so cards injected later (Constructor, quick view, carousels) are covered.
// Same condition as the CSS that reveals the secondary image; touch taps also fire mouseover/focusin.
const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)')

document.addEventListener('mouseover', (event) => {
  if (hoverCapable.matches) loadCardSecondaryImage(event.target)
})
document.addEventListener('focusin', (event) => {
  if (hoverCapable.matches) loadCardSecondaryImage(event.target)
})

// The lifestyle grid view shows the secondary image without hover, so load it as cards near the viewport.
const observer =
  'IntersectionObserver' in window
    ? new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          observer.unobserve(entry.target)

          // Skip if the grid switched back to default view; the next switch to lifestyle re-observes it.
          if (entry.target.closest(LIFESTYLE_GRID_SELECTOR)) {
            loadSecondaryImage(entry.target)
          }
        })
      },
      { rootMargin: '200px 0px' },
    )
    : null

function observeImage (img) {
  if (observer) {
    observer.observe(img)
  } else {
    loadSecondaryImage(img)
  }
}

function observeLifestyleImagesIn (root) {
  if (!root.closest(LIFESTYLE_GRID_SELECTOR)) return

  if (root.matches(SECONDARY_IMAGE_SELECTOR)) {
    observeImage(root)
  }

  root.querySelectorAll(SECONDARY_IMAGE_SELECTOR).forEach(observeImage)
}

document
  .querySelectorAll(`${LIFESTYLE_GRID_SELECTOR} ${SECONDARY_IMAGE_SELECTOR}`)
  .forEach(observeImage)

// Only the grid view toggle and newly added subtrees are inspected, not the whole document.
new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'attributes') {
      if (mutation.target.matches(LIFESTYLE_GRID_SELECTOR)) {
        observeLifestyleImagesIn(mutation.target)
      }

      return
    }

    mutation.addedNodes.forEach((node) => {
      if (node instanceof Element) {
        observeLifestyleImagesIn(node)
      }
    })
  })
}).observe(document.body, {
  attributes: true,
  attributeFilter: ['class'],
  childList: true,
  subtree: true,
})
